import * as Yup from 'yup';

import { FORBIDDEN_TERMS, PASSWORD_REQUIREMENTS, VALIDATION_MESSAGES } from './constants';

export const MAX_PHONE_LENGTH_BY_COUNTRY = {
  MEX: 13,
  PER: 12,
  COL: 13,
  CHL: 12,
};

const PHONE_PREFIX_TO_LENGTH: { prefix: string; length: number; digits: number }[] = [
  { prefix: '+52', length: 13, digits: 10 }, // México
  { prefix: '+57', length: 13, digits: 10 }, // Colombia
  { prefix: '+56', length: 12, digits: 9 }, // Chile
  { prefix: '+51', length: 12, digits: 9 }, // Perú
];

export const createNewUserSchema = () => {
  return Yup.object().shape({
    organizationCode: Yup.string()
      .trim('El campo solo contiene espacios en blanco')
      .required('Campo obligatorio'),
    user: Yup.string()
      .email('El email tiene un formato inválido.')
      .required('Este campo es requerido'),
    firstName: Yup.string()
      .trim('El campo solo contiene espacios en blanco')
      .required('Este campo es requerido'),
    lastName: Yup.string()
      .trim('El campo solo contiene espacios en blanco')
      .required('Este campo es requerido'),
    phone: Yup.string()
      .required('Este campo es requerido')
      .test('phone-length-by-country', 'El número de teléfono no es válido', function (value) {
        if (!value) return true;

        const normalizedPhone = value.replace(/\s/g, '');

        if (!/^\+\d+$/.test(normalizedPhone)) {
          return this.createError({
            message: 'El número de teléfono solo puede contener caracteres numéricos',
          });
        }

        const matchPrefix = PHONE_PREFIX_TO_LENGTH.find(({ prefix }) =>
          normalizedPhone.startsWith(prefix),
        );

        if (!matchPrefix) {
          return this.createError({ message: 'Selecciona un país válido' });
        }

        if (normalizedPhone.length !== matchPrefix.length) {
          return this.createError({
            message: `El número debe tener ${matchPrefix.digits} dígitos`,
          });
        }

        return true;
      }),
    password: Yup.string()
      .min(PASSWORD_REQUIREMENTS.MIN_LENGTH, VALIDATION_MESSAGES.PASSWORD.MIN_LENGTH)
      .max(PASSWORD_REQUIREMENTS.MAX_LENGTH, VALIDATION_MESSAGES.PASSWORD.MAX_LENGTH)
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\/;]).+$/,
        VALIDATION_MESSAGES.PASSWORD.PATTERN,
      )
      .test('no-company-terms', VALIDATION_MESSAGES.PASSWORD.NO_COMPANY_TERMS, function (value) {
        if (!value) return true;

        const lowercaseValue = value.toLowerCase();

        for (const term of FORBIDDEN_TERMS) {
          if (lowercaseValue.includes(term)) {
            return false;
          }
        }

        return true;
      })
      .test('no-personal-info', VALIDATION_MESSAGES.PASSWORD.NO_PERSONAL_INFO, function (value) {
        if (!value) return true;

        const { firstName, lastName, user } = this.parent;
        const lowercasePassword = value.toLowerCase();

        if (firstName && firstName.length >= 4) {
          const nameLower = firstName.toLowerCase();
          for (let i = 0; i <= nameLower.length - 4; i++) {
            const sequence = nameLower.substring(i, i + 4);
            if (lowercasePassword.includes(sequence)) {
              return false;
            }
          }
        }

        if (lastName && lastName.length >= 4) {
          const lastNameLower = lastName.toLowerCase();
          for (let i = 0; i <= lastNameLower.length - 4; i++) {
            const sequence = lastNameLower.substring(i, i + 4);
            if (lowercasePassword.includes(sequence)) {
              return false;
            }
          }
        }

        if (user) {
          const emailPart = user.split('@')[0].toLowerCase();
          if (emailPart.length >= 4) {
            for (let i = 0; i <= emailPart.length - 4; i++) {
              const sequence = emailPart.substring(i, i + 4);
              if (lowercasePassword.includes(sequence)) {
                return false;
              }
            }
          }
        }

        return true;
      })
      .required('Este campo es requerido'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), undefined], VALIDATION_MESSAGES.PASSWORD.PASSWORDS_MATCH)
      .required('Este campo es requerido'),
  });
};
